<script>
    import { getp_no_catch } from '../lib/ldcjs/getp';
    import { set_event_context, log_event } from '../lib/ldcjs/recording_events';
    import * as RadioGroup from "$lib/components/ui/radio-group/index.js";
    import { Label } from "$lib/components/ui/label/index.js";
    import { onMount } from 'svelte';
    import { writable } from 'svelte/store';
    import { btn, dbtn } from './buttons.js';
    import Meter from './level_meter.svelte';
	import { CircleDot, CircleStop, Check, Camera, Mic } from '@lucide/svelte';
    import { set_ldc, done, donex, annotatex } from '../lib/ldcjs/waveform/modification1';
    import { refreshToken, getSignedUrlPromise, uploadObject, s3url } from '../lib/ldcjs/aws_helper';
    import { fromCognitoIdentity } from "@aws-sdk/credential-provider-cognito-identity";
    import { CognitoIdentityClient } from "@aws-sdk/client-cognito-identity";
    import { TranscribeClient } from "@aws-sdk/client-transcribe";
    import { S3Client, GetObjectCommand, HeadObjectCommand, ListObjectsV2Command, PutObjectCommand } from "@aws-sdk/client-s3";
    import { Upload } from "@aws-sdk/lib-storage";
    import { getSignedUrl } from "@aws-sdk/s3-request-presigner";
    import { request_animation_frame_loop_init } from '../lib/ldcjs/request_animation_frame_loop';
    import {
		set_audio_element_with_url,
		play_src_with_audio_id,
		getUserMedia,
		create_blob,
		filename_from_date,
		create_node_graph,
		get_audio_context
        // play_callback,
        // callf,
        // is_playing,
        // set_playback_rate,
        // set_audio_element,
        // set_audio_id_to_channel,
        // decode_audio_data,
        // stop_playing
    } from '../lib/ldcjs/audio/main';
	import { WaveRiff } from '../lib/ldcjs/audio/wave_riff';
    import AudioPlayer from './audio_player.svelte'
    let page = $state(1);

    async function finish(){
        // never navigate away from the site with a recording still uploading:
        // leaving here is what used to lose the closing recording
        await flush_uploads();
        const cc = window.ldc.obj2.cc;
        log_event('session_finish', { cc: cc });
        window.location.href = `https://app.prolific.com/submissions/complete?cc=${cc}`;
        // window.location.href = `https://wikipedia.org`;
        // alert(`here ${cc}`);
    }

    let i = window.ldc.last_iid + 1;

    set_ldc(window.ldc);

    setTimeout( () => {
        if(window.ldc.nodes.size == 0){
            // annotatex('List', "add", `${i}:ListItem,${i+1}:Response`);
            annotatex('List', "add", `1:ListItem,2:Response`);
            annotatex('List', "add", `3:ListItem,4:Response`);
            annotatex('List', "add", `5:ListItem,6:Response`);
            annotatex('List', "add", `7:ListItem,8:Response`);
        }
    }, 1000);

    // setTimeout( () => {
    //     if(window.ldc.nodes.size == 2){
    //         // annotatex('List', "add", `${i}:ListItem,${i+1}:Response`);
    //         annotatex('List', "add", `3:ListItem,4:Response`);
    //     }
    // }, 2000);

    // setTimeout( () => {
    //     if(window.ldc.nodes.size == 4){
    //         // annotatex('List', "add", `${i}:ListItem,${i+1}:Response`);
    //         annotatex('List', "add", `5:ListItem,6:Response`);
    //     }
    // }, 3000);

    const choices = [
        { id: '0', value: '0: None' },
        { id: '1', value: '1: Very Mild'},
        { id: '2', value: '2: Mild'},
        { id: '3', value: '3: Moderate'},
        { id: '4', value: '4: Severe'},
        { id: '5', value: '5: Very Severe'}
    ];

    // Task timing constants
    const TASK1_MIN_SECONDS = 120;   // 2 minutes minimum
    const TASK1_TARGET_SECONDS = 180; // 3 minutes target
    const TASK2_MIN_SECONDS = 60;    // 1 minute minimum
    const TASK2_TARGET_SECONDS = 120; // 2 minutes target
    const TASK3_MIN_SECONDS = 20;    // 1 minute minimum
    const TASK3_TARGET_SECONDS = 90; // 2 minutes target
    let stop_after_this_duration = 0;

    function b(){
        page++;
    }

    // kept so credentials can be renewed mid-session: a session that outlives
    // its cognito credentials used to fail every upload from then on
    const aws_deps = {
        fromCognitoIdentity,
        CognitoIdentityClient,
        TranscribeClient,
        S3Client,
        GetObjectCommand,
        HeadObjectCommand,
        ListObjectsV2Command,
        PutObjectCommand,
        Upload,
        getSignedUrl
    };
    refreshToken(aws_deps);
    
    // import { stream_store } from '$lib/stores'
    // const stream_store = writable(null);
    let stream = $state();
    // stream_store.subscribe( (x) => stream = x );


	let new_builder = () => new WaveRiff('builder');

	let stream_record = 'stream';
	let streaming = $state(false);
    let streamed_once = $state(false);
	let record = $state(false);
	let recording_object = {};
    let chunks = [];
    let blob = $state();
    let filename = '';


	onMount( async () => {
		// const m = await import(`${ldcjs}/request_animation_frame_loop.js`);
		request_animation_frame_loop_init();
		window.ldc.vars.loop.set('time_callback', timef);
    });

    let start_time = 0;
	let seconds = $state(0);
    let seconds_integer = $derived(Math.round(seconds));
	function timef(){
		if(start_time) seconds = (Date.now() - start_time)/1000;
        if(record && seconds >= stop_after_this_duration){
            stop_simple2();
            page++;
        }
	}

	// $: show_recording = chunks.length;
	// let show_recorder = true;


	let meter_level = $state(0);
	// the data processing function sets an RMS value in a meter
	const analyzef = (time_domain, freq_domain) => meter_level = rms(time_domain);
	// const analyzef = () => console.log('here');
	const onstopf = () => console.log('done');

	let audio_context;
	async function audio_context_init(){
		if(!audio_context){
	 		audio_context = get_audio_context();
	    	await audio_context.resume();
			await audio_context.audioWorklet.addModule('/recording_processor.js');
		}
		return audio_context;
	}

	async function start_simple(){
        const fn = filename_from_date();
        filename = `${ldc.obj._id}_${fn}`;
		start_recording(stream_record);
	}

    // The recording's name is annotated (and so written to the response row)
    // when recording starts, not when the upload lands, so a session abandoned
    // mid-task leaves a name behind with no audio.  The upload_ok event is what
    // says the audio actually arrived; the two are reconciled after the fact.
    function annotate_filename(node, fn){
        log_event('annotate_send', { node: node, value: fn }, { filename: fn });
        annotatex(node, 'change', { value: fn });
    }

    function start_task(tag, node, duration){
        const fn = filename_from_date();
        filename = `${ldc.obj._id}_${tag}_${fn}`;
        start_simple2();
        log_event('record_start', { tag: tag, node: node, target_seconds: duration }, { filename: filename });
        annotate_filename(node, filename);
        stop_after_this_duration = duration;
    }

    function page4(){
        page = 4;
        start_task('A001', '2', TASK1_TARGET_SECONDS);
    }

    function page5(){
        page = 5;
        stop_simple2();
    }

    let page4rok = $state(true);
    function page4r(){
        page = 3;
		stop_recording();
        page4rok = false;
    }

    function page6(){
        blob = null;
        page = 6;
        if(!picture_ok){
            // the picture code never resolved, so this recording is about to be
            // named _0000_ and its response row is probably unbound too
            log_event('picture_unresolved', { at: 'task2_start', picture_code: pn }, { ok: false });
        }
        start_task(pn, '4', TASK2_TARGET_SECONDS);
    }

    function page7(){
        page = 7;
        stop_simple2();
    }

    let page6rok = $state(true);
    function page6r(){
        page = 5;
		stop_recording();
        page6rok = false;
    }

    function page8(){
        blob = null;
        page = 8;
        start_task('Z003', '6', TASK3_TARGET_SECONDS);
    }

    function page9(){
        page = 9;
        stop_simple2();
    }

    let page8rok = $state(true);
    function page8r(){
        page = 7;
		stop_recording();
        page8rok = false;
    }

    function start_simple2(){
        stream_record = 'record';
		start_recording(stream_record);
    }

	async function start_recording(stream_record){
        // synchronously, before the first await: the caller reads blob_promise
        // as soon as this take is stopped, and must not be handed the previous
        // take's audio
        blob_promise = new Promise( (resolve) => blob_resolve = resolve );
        await access_hardware();
		start_time = Date.now();
        streaming = true;
        streamed_once = true;
        if(stream_record == 'record'){
            record = true;
			await audio_context_init();
        }
        const script_processor = false;
        const audio_worklet = true;
        recording_object = create_node_graph({
            stream,
            record,
            onstopf,
            analyzef,
            script_processor,
            audio_worklet
        });
        // the following assignment is what sets the callback to be called

        window.ldc.vars.loop.set('stream_callback', recording_object.analyze);

		if(recording_object.worklet){
			recording_object.worklet.port.onmessage = (e) => {
				console.log(e);
				chunks = e.data;
		        if(chunks.length){
        		    blob = create_blob(chunks, new_builder());
            		console.log(blob);
                    // hand this recording's audio to whoever is waiting to
                    // upload it, so it can't be confused with the next one
                    if(blob_resolve) blob_resolve(blob);
        		}
			}
		}
        else{
            console.log('no worklet');
        }
    }

	function stop_simple(){
		stop_recording();
	}

    // let uploading = $state(0);
    // The filename is captured here rather than read inside upload(): the next
    // task overwrites `filename` as soon as the participant starts it, and a
    // slow upload used to be able to pick up the following task's name.
    function stop_simple2(){
        const fn = filename;
        const bp = blob_promise;
		stop_recording();
        pending_uploads++;
        uploads_promise = uploads_promise
            .then( () => upload(fn, bp) )
            .catch( (e) => console.error('upload chain error', e) )
            .finally( () => pending_uploads-- );
        return uploads_promise;
	}

    function stop_recording(){
		start_time = 0;
        streaming = false;
        record = false;
        // stream = null;
		if(recording_object){
			recording_object.destroy();
			window.ldc.vars.loop.delete('stream_callback'); // stop callback
		}
    }

	function rms(time_domain){
		let sum = 0;
		for(let i = 0; i < time_domain.length; i++){
			let v = Math.abs(time_domain[i]);
			sum += v * v;
		}
		return Math.sqrt(sum / time_domain.length);
	}

    let levels_ok = $state(false);
    function pagel(){
        levels_ok = true;
        page++;
    }

    // Uploads are serialised through this chain and pending_uploads counts the
    // ones still in flight, so the session can refuse to end while audio is
    // still on its way to S3.
    let uploads_promise = Promise.resolve();
    let pending_uploads = $state(0);
    let blob_promise = null;
    let blob_resolve = null;
    const UPLOAD_ATTEMPTS = 4;
    const BLOB_TIMEOUT_MS = 60000;

    function sleep(ms){
        return new Promise( (resolve) => setTimeout(resolve, ms) );
    }

    // resolves with the recording, or null if the worklet never produced one
    function wait_for_blob(bp){
        if(!bp) return Promise.resolve(blob);
        return Promise.race([ bp, sleep(BLOB_TIMEOUT_MS).then( () => null ) ]);
    }

    async function upload(fn, bp){
        const file = await wait_for_blob(bp);
        if(!file){
            log_event('upload_abandoned', { reason: 'no audio data from recorder' }, { filename: fn, ok: false });
            return false;
        }
        blob = null;
        return upload3(file, fn);
    }

    async function upload3(file, fn){
        console.log(file);
        const key = `vital/collection/${fn}.wav`;

        for(let attempt = 1; attempt <= UPLOAD_ATTEMPTS; attempt++){
            uploadStatus = 'uploading';
            uploadProgress = 0;
            log_event('upload_start', { key: key, size: file.size, attempt: attempt }, { filename: fn });

            try {
                await uploadObject('ldc-northwell-data', key, file, (progress) => {
                    uploadProgress = progress;
                });

                uploadStatus = 'complete';
                log_event('upload_ok', { key: key, size: file.size, attempt: attempt }, { filename: fn, ok: true });

                // Hide the upload indicator after 2 seconds
                setTimeout(() => {
                    uploadStatus = 'idle';
                    uploadProgress = 0;
                }, 2000);
                return true;
            } catch (error) {
                console.error('Upload error:', error);
                log_event(
                    'upload_fail',
                    { key: key, attempt: attempt, error: String((error && error.message) || error) },
                    { filename: fn, ok: false }
                );
                if(attempt < UPLOAD_ATTEMPTS){
                    // most likely cause of a repeated failure is credentials
                    // that expired part way through a long session
                    log_event('upload_retry', { key: key, attempt: attempt }, { filename: fn });
                    refreshToken(aws_deps);
                    await sleep(2000 * attempt);
                }
                else {
                    uploadStatus = 'error';
                    log_event('upload_abandoned', { key: key, attempts: attempt }, { filename: fn, ok: false });

                    // Hide error message after 5 seconds
                    setTimeout(() => {
                        uploadStatus = 'idle';
                        uploadProgress = 0;
                    }, 5000);
                    return false;
                }
            }
        }
        return false;
    }

    // wait for everything queued so far, so the participant is not sent away
    // while the last recording is still uploading
    function flush_uploads(){
        if(pending_uploads > 0) log_event('flush_uploads', { pending: pending_uploads });
        return uploads_promise.catch( () => null );
    }
    
    let kit = true;
    let streamp;
	const constraints = {
        audio: true,
        video: false
    };
    async function access_hardware(){
		if(!streamp) streamp = navigator.mediaDevices.getUserMedia(constraints);
		// streamp.then( (x) => stream_store.set(x) );
		if(!stream) return streamp.then( (x) => stream = x );
	}


    let selectedRadioValue = $state(null);
    let showReturnConfirmation = $state(false);
    let returnCallback = $state(null);

    // Upload progress state
    let uploadStatus = $state('idle'); // 'idle', 'uploading', 'complete', 'error'
    let uploadProgress = $state(0);

    function radiochangef(x){
        selectedRadioValue = x;
        annotatex(`8`, 'change', { value: x });
    }

    let picture = $state(null);
    let pn = '0000';
    let picture_ok = $state(false);

    // This one request does two things: it hands back the picture code for
    // task 2, and it is what binds the response row to this kit on the server.
    // When it failed the client used to swallow the error, so the recording was
    // named _0000_ *and* the session never appeared in the response table --
    // the two halves of the same failure.  Retry it, and say so when it fails.
    const RESPONSE_SETS_ATTEMPTS = 5;
    async function load_response_sets(){
        for(let attempt = 1; attempt <= RESPONSE_SETS_ATTEMPTS; attempt++){
            try {
                const sets = await getp_no_catch(`/response_sets?kit_id=${ldc.vars.kit_id}`);
                console.log('sets');
                const found = (sets || []).find( (x) => x.session == ldc.obj.task_name );
                if(!found) throw new Error(`no response row for session ${ldc.obj.task_name}`);
                console.log(found);
                set_event_context({ session: found.session, sessionn: found.sessionn });
                if(!found.picture) throw new Error('response row has no picture code');
                // picture = 'vital/uploads/2662290144';
                pn = found.picture;
                picture = `vital/pictures/${found.picture}.png`;
                picture_ok = true;
                log_event(
                    'picture_resolved',
                    { picture: found.picture, response_set_id: found.id, kit_uid: found.kit_uid, attempt: attempt }
                );
                return found;
            }
            catch(e) {
                log_event(
                    'picture_unresolved',
                    { attempt: attempt, error: String((e && e.message) || e), kit_id: ldc.vars.kit_id },
                    { ok: false }
                );
                if(attempt < RESPONSE_SETS_ATTEMPTS) await sleep(2000 * attempt);
            }
        }
        return null;
    }

    set_event_context({ kit_uid: ldc.obj._id });
    log_event('session_start', {
        kit_id: ldc.vars.kit_id,
        task_name: ldc.obj.task_name,
        user_agent: navigator.userAgent
    });
    load_response_sets();

    // a session whose page goes away with audio still in flight is exactly how
    // the closing recording gets lost, so leave a record of it
    onMount( () => {
        const warn = (e) => {
            if(pending_uploads > 0){
                log_event('unload_with_pending_uploads', { pending: pending_uploads, page: page }, { ok: false });
                e.preventDefault();
                e.returnValue = '';
                return '';
            }
        };
        window.addEventListener('beforeunload', warn);
        return () => window.removeEventListener('beforeunload', warn);
    });

</script>
    <!-- <button class="{btn}" onclick={donex}>done</button> -->

<div class="flex justify-center">
	<!-- <button class="{btn} flex" onclick={access_hardware}><Mic/><Camera/><span>Access Hardware</span></button> -->
	<!-- <button class="{btn} flex" onclick={access_hardware}><Mic/><span>Access Mic</span></button>
	{#if stream}
    	<div>mic is on</div>
	{/if}
    {#if record}
        <div>recording for {seconds_integer} seconds</div>
    {/if} -->
</div>

<!-- {#await getSignedUrlPromise('ldc-northwell-data','vital/uploads/4020779727')}
                        loading...
                    {:then v} -->
                        <!-- <div>
                            <img src="{v}" alt="pic" width="500" height="600">
                        </div> -->
    <!-- <AudioPlayer url={v} blob={null} filename="foo" /> -->
                    <!-- {/await} -->


<!-- {#if blob}
    <AudioPlayer url=null {blob} filename="foo" play={false} />
{:else}
    no blob
{/if} -->

{#snippet header(x)}
    <h1 class="text-blue-500">{x}</h1>
{/snippet}

{#snippet p(x)}
    <p>{x}</p>
{/snippet}

{#snippet purpleHeader(text)}
    <h2 class="text-3xl font-semibold" style="color: #4D2DB7;">{text}</h2>
{/snippet}

{#snippet outlineButton(text, clickHandler, disabled = false)}
    <button class="border-2 {disabled ? 'border-gray-300 text-gray-300 cursor-not-allowed' : 'border-green-500 hover:border-green-600 text-green-500 hover:text-green-600'} font-bold py-3x px-6 rounded-lg text-3xl" 
            onclick={disabled ? null : clickHandler} 
            {disabled}>{text}</button>
{/snippet}

{#snippet returnToInstructionsButton(text, clickHandler, disabled = false)}
    <button class="border-2 {disabled ? 'border-gray-300 text-gray-300 cursor-not-allowed' : 'border-green-500 hover:border-green-600 text-green-500 hover:text-green-600'} font-bold py-1x px-6 rounded-lg text-sm" 
            onclick={disabled ? null : clickHandler} 
            {disabled}>{text}</button>
{/snippet}

{#snippet solidButton(text, clickHandler)}
    <button class="bg-green-500 hover:bg-green-600 text-white font-bold py-3x px-6 rounded-lg text-3xl" onclick={clickHandler}>{text}</button>
{/snippet}

{#snippet stopButton(text, clickHandler)}
    <button class="bg-red-500 hover:bg-red-600 text-white font-bold py-3x px-6 rounded-lg text-3xl" onclick={clickHandler}>{text}</button>
{/snippet}

{#snippet recordingIndicator()}
    <div class="text-3xl font-bold text-red-500 mb-4x">RECORDING</div>
    <Meter v={meter_level} clipped={.99} navg={10} />
{/snippet}

{#snippet audioLoader(s3Key)}
    <div class="mb-6x">
        {#await getSignedUrlPromise('ldc-northwell-data', s3Key)}
            <div class="text-center py-4">Loading audio...</div>
        {:then v}
            <AudioPlayer url={v} blob={null} filename="foo" play={true} />
        {/await}
    </div>
{/snippet}

{#snippet pageContainer(content)}
    <div class="space-y-6x text-center" style="color: #4D2DB7;">
        {@render content()}
    </div>
{/snippet}

{#snippet taskHeader(text)}
    <h2 class="text-xl font-semibold" style="color: #4D2DB7;">{text}</h2>
{/snippet}

{#snippet taskHeader2(text)}
    <h2 class="text-lg font-semibold" style="color: #4D2DB7;">{text}</h2>
{/snippet}

{#snippet recordingSection(currentSeconds, minSeconds, targetSeconds, finishHandler)}
    {@render recordingIndicator()}
    {#if targetSeconds > 0}
        {@render progressMeter(currentSeconds, minSeconds, targetSeconds)}
    {/if}
    
    <div class="text-center pt-4x">
        {@render outlineButton("Finish", finishHandler, currentSeconds < minSeconds)}
    </div>
{/snippet}

{#snippet progressMeter(currentSeconds, minSeconds, targetSeconds)}
    <div class="w-full max-w-sm mx-auto mb-4x">
        <div class="flex justify-between text-sm mb-2x">
            <span>{Math.floor(currentSeconds / 60)}:{(Math.floor(currentSeconds) % 60).toString().padStart(2, '0')}</span>
            <span>{Math.floor(targetSeconds / 60)}:{(targetSeconds % 60).toString().padStart(2, '0')}</span>
        </div>
        <div class="w-full h-3 relative" style="background: linear-gradient(to right, #fecaca 0%, #fecaca {(minSeconds / targetSeconds) * 100}%, #bbf7d0 {(minSeconds / targetSeconds) * 100}%, #bbf7d0 100%)">
            <div class="h-3 transition-all duration-100 relative overflow-hidden" 
                 style="width: {Math.min((currentSeconds / targetSeconds) * 100, 100)}%; background: linear-gradient(to right, #ef4444 0%, #ef4444 {currentSeconds < minSeconds ? 100 : (minSeconds / currentSeconds) * 100}%, #22c55e {currentSeconds < minSeconds ? 100 : (minSeconds / currentSeconds) * 100}%, #22c55e 100%)"></div>
        </div>
    </div>
{/snippet}
    <!-- <button class="{btn}" onclick={annotate}>annotate</button> -->
    <!-- <button class="{btn}" onclick={done}>done</button> -->

{#snippet returnButton(f)}
    <div class="text-center pt-4x">
        {@render returnToInstructionsButton("Return to Instructions", () => {
            showReturnConfirmation = true;
            returnCallback = f;
        })}
    </div>
{/snippet}

{#if !page}
    <!-- <button class="{btn}" onclick={() => page = 1}>start</button> -->
{/if}

<div class="max-w-md mx-auto px-4 sm:px-6 md:px-8">
    {#if page == 1}
        <div id="page1" class="space-y-4x text-center" style="color: #4D2DB7;">
            {@render purpleHeader("Welcome to the VITAL speech collection tool!")}
            <div class="flex justify-center">
                {#await getSignedUrlPromise('ldc-northwell-data','vital/uploads/3070225904')}
                    <div class="text-center xpy-8">Loading video...</div>
                {:then v}
                    <!-- svelte-ignore a11y_media_has_caption -->
                    <video width="320" height="240" controls class="rounded-lg">
                        <source src="{v}" type="video/mp4">
                        Your browser does not support the video tag.
                    </video>
                {/await}
            </div>
            <div class="space-y-3x text-center" style="color: #4D2DB7;">
                <p class="text-xl text-center font-medium">Click here to start your next session.</p>
            </div>
            <div class="pt-6x">
                {@render outlineButton("START", () => page = 2)}
            </div>
        </div>
    {/if}
    {#if page == 2}
        <div id="page2" class="text-2xl text-center space-y-2" style="color: #4D2DB7;">
            {@render purpleHeader("Instructions")}
            <div class="text-base space-y-3x text-center" style="color: #4D2DB7;">
                <p>As a reminder, providing your speech sample is part of your participation in the research study "VITAL."</p>
                <p>Please join from a private, quiet spot and make sure your device has a working microphone.</p>
            </div>
            <p>Before proceeding, test that your microphone is working.</p>
            <div class="text-base space-y-3x text-center" style="color: red;">
                <p>If the Test button doesn't display the microphone check, please check your <span class="font-semibold">device settings</span> to enable microphone access for your web browser.</p>
            </div>

                {#if streaming}
                    <Meter v={meter_level} clipped={.99} navg={10} />
                    <div class="mx-6">Audio bar should move.</div>
                    {@render stopButton("STOP", stop_simple)}
                {:else}
                    <div>
                        {@render solidButton("TEST", start_simple)}
                    </div>
                    {#if streamed_once}
                        <div class="pt-4x">
                            {@render solidButton("Levels OK?", () => page = 3 )}
                        </div>
                    {/if}
                {/if}

        </div>
    {/if}
    {#if page == 3}
        <div id="page3" class="space-y-2 text-center" style="color: #4D2DB7;">
            {@render audioLoader('vital/uploads/5722974867')}
            {@render purpleHeader("Task 1 Instructions")}
            
            <div class="space-y-4x">
                <p>We are going to ask you some open-ended questions on the next screen.</p>
                <p>Please respond to the following prompts with as much detail as possible.</p>
                <p class="font-mediumx xtext-amber-600">As a reminder, avoid saying identifying information like your name, address, or date of birth.</p>
            </div>
            
            <p class="font-semibold">Please keep speaking for 2-3 minutes.</p>
            
            <div class="text-center pt-4x">
                {@render outlineButton("Start Task", page4)}
            </div>
        </div>
    {/if}
    {#if page == 4}
        <div id="page4" class="text-center space-y-2">
            <div>
            {#if page4rok}
                {@render returnButton(page4r)}
            {/if}
            {@render taskHeader("Task 1: Please respond to the following. Please keep speaking for 2-3 minutes.")}
            <div class="space-y-4x px-4 rounded-lg">
                <div class="font-mediumx italic" style="color: #4D2DB7;">(Respond in any order you'd like, circling back if you wish.)</div>
            </div>
            </div>
            
            <ul class="list-disc text-left space-y-4x px-4 rounded-lg">
                <li class="font-mediumx">How have things been going recently?</li>
                <li class="font-mediumx">What's been on your mind?</li>
                <li class="font-mediumx">Tell us about your daily routine or if anything has changed.</li>
                <li class="font-mediumx">Has anything been causing you any stress?</li>
                <li class="font-mediumx">What about pleasant experiences you've had?</li>
                <li class="font-mediumx">Is there anything you're looking forward to?</li>
            </ul>
            
            {@render recordingSection(seconds, TASK1_MIN_SECONDS, TASK1_TARGET_SECONDS, page5)}
        </div>
    {/if}
    {#if page == 5}
        <div id="page5" class="space-y-2 text-center" style="color: #4D2DB7;">
            {@render audioLoader('vital/uploads/4020779727')}
            {@render purpleHeader("Task 2 Instructions")}
            
            <div class="space-y-4x">
                <p>You will see a picture on the next screen.</p>
                <p>Please describe the picture as fully as you can.</p>
                <p>Tell us what you see in the picture, including any details.</p>
                <p>Tell us what you think might be happening and how you feel about it.</p>
            </div>
            
            <p class="font-semibold">Please keep speaking for 1-2 minutes.</p>

            <div class="text-center pt-4x">
                {@render outlineButton("Start Task", page6)}
            </div>
        </div>
    {/if}
    {#if page == 6}
        <div id="page6" class="space-y-2 text-center">
            {#if page6rok}
                {@render returnButton(page6r)}
            {/if}
            {@render taskHeader("Task 2: Please talk about this picture. Keep speaking for 1-2 minutes.")}
            
            <div class="flex justify-center">
                {#if picture}
                    {#await getSignedUrlPromise('ldc-northwell-data', picture)}
                        <div class="text-center py-8x">Loading image...</div>
                    {:then v}
                        <!-- svelte-ignore a11y_img_redundant_alt -->
                        <img src="{v}" alt="Task image for description" class="max-w-full h-auto rounded-lg shadow-md">
                    {/await}
                {:else}
                    <div>picture not found</div>
                {/if}
            </div>
            
            {@render recordingSection(seconds, TASK2_MIN_SECONDS, TASK2_TARGET_SECONDS, page7)}
        </div>
    {/if}
    {#if page == 7}
        <div id="page7" class="space-y-2 text-center" style="color: #4D2DB7;">
            {@render audioLoader('vital/uploads/3960847696')}
            {@render purpleHeader("Task 3 Instructions")}
            
            <div class="space-y-4x">
                <p>On the following page, you will see a passage.</p>
                <p>Please read the passage aloud.</p>
            </div>
            
            <div class="text-center pt-4x">
                {@render outlineButton("Start Task", page8)}
            </div>
        </div>
    {/if}
    {#if page == 8}
        <div id="page8" class="space-y-2 text-center">
            {#if page8rok}
                {@render returnButton(page8r)}
            {/if}
            {@render taskHeader2("Please read the following paragraph aloud.")}
            <!-- <div class="text-xs">
                <div>You wish to know about my grandfather. Well, he is nearly</div>
                <div>93 years old, yet he still thinks as swiftly as ever. He</div>
                <div>dresses himself in an old black frock coat, usually several</div>
                <div>buttons missing. A long beard clings to his chin, giving</div>
                <div>those who observe him a pronounced feeling of the utmost</div>
                <div>respect. When he speaks, his voice is just a bit cracked</div>
                <div>and quivers a bit. Twice each day he plays skillfully and</div>
                <div>with zest upon a small organ. Except in the winter when</div>
                <div>the snow or ice prevents, he slowly takes a short walk in</div>
                <div>the open air each day. We have often urged him to walk</div>
                <div>more and smoke less, but he always answers, “Banana</div>
                <div>oil!” Grandfather likes to be modern in his language.</div>
            </div> -->
            <div class="text-base text-left">
                The North Wind and the Sun were disputing which was the stronger,
                when a traveler came along wrapped in a warm cloak.
                They agreed that the one who first succeeded in making the traveler
                take his cloak off should be considered stronger than the other.
                Then the North Wind blew as hard as he could, but the more he blew
                the more closely did the traveler fold his cloak around him; and at
                last the North Wind gave up the attempt. Then the Sun shined out warmly,
                and immediately the traveler took off his cloak. And so the North Wind
                was obliged to confess that the Sun was the stronger of the two.
            </div>
            {@render recordingSection(seconds, TASK3_MIN_SECONDS, TASK3_TARGET_SECONDS, page9)}
        </div>
    {/if}
    {#if page == 9}
        <div id="page9" class="text-2xl space-y-6x text-center" style="color: #4D2DB7;">
            <p>Please rate the overall severity of your symptoms right now:</p>
            
            <RadioGroup.Root class="space-y-4x max-w-xs mx-auto" onValueChange={radiochangef}>
                {#each choices as x}
                    <div class="flex items-center justify-start space-x-4 py-3x px-16 rounded-lg hover:bg-gray-50">
                        <RadioGroup.Item value={x.id} id={`id-${x.id}`} class="w-6 h-6" />
                        <Label for={`id-${x.id}`} class="text-lg cursor-pointer">{x.value}</Label>
                    </div>
                {/each}
            </RadioGroup.Root>            
            <div class="text-center pt-4x">
                {@render outlineButton("Finish", () => page = 10, selectedRadioValue === null)}
            </div>
        </div>
    {/if}
    {#if page == 10}
        <div id="page10" class="text-2xl space-y-6x text-center" style="color: #4D2DB7;">
            <div class="flex justify-center">
                <div class="relative">
                    {#await getSignedUrlPromise('ldc-northwell-data','vital/uploads/thx.mp4')}
                        <div class="text-center py-8x">Loading video...</div>
                    {:then v}
                        <!-- svelte-ignore a11y_media_has_caption -->
                        <video width="320" height="240" controls playsinline autoplay="true" loop class="rounded-lg">
                            <source src="{v}" type="video/mp4">
                            Your browser does not support the video tag.
                        </video>
                    {/await}
                    {#await getSignedUrlPromise('ldc-northwell-data','vital/uploads/0971321946')}
                        <div class="absolute inset-0 flex items-center justify-center">
                            <div class="text-center py-8x">Loading image...</div>
                        </div>
                    {:then v}
                        <!-- svelte-ignore a11y_img_redundant_alt -->
                        <img src="{v}" alt="Task image for description" class="absolute top-20 w-60 h-45 xobject-cover rounded-lg shadow-md opacity-75" style="left: 30px">
                    {/await}
                </div>
            </div>
            <div class="space-y-4x">
                <p class="text-5xl">See you next week!</p>
                <div class="text-lg space-y-2x">
                    {#if window.ldc.obj2.ccp}
                    <span>Click here if you are a Prolific participant:</span>
                        <!-- Complete Study -->
                        {@render solidButton("Complete Study", finish)}
                    {/if}
                </div>
            </div>
        </div>
    {/if}
</div>

<!-- Upload Progress Indicator -->
{#if uploadStatus !== 'idle'}
    <div class="fixed bottom-4 right-4 z-50">
        <div class="bg-white rounded-lg shadow-xl border-2 {uploadStatus === 'complete' ? 'border-green-500' : uploadStatus === 'error' ? 'border-red-500' : 'border-blue-500'} px-6 py-4 min-w-[300px]">
            {#if uploadStatus === 'uploading'}
                <div class="space-y-3">
                    <div class="flex items-center space-x-3">
                        <svg class="animate-spin h-5 w-5 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        <span class="font-semibold text-gray-800">Uploading audio...</span>
                    </div>
                    <div class="w-full bg-gray-200 rounded-full h-2.5">
                        <div class="bg-blue-500 h-2.5 rounded-full transition-all duration-300" style="width: {uploadProgress}%"></div>
                    </div>
                    <div class="text-sm text-gray-600 text-right">{uploadProgress}%</div>
                </div>
            {:else if uploadStatus === 'complete'}
                <div class="flex items-center space-x-3 text-green-600">
                    <svg class="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                    <span class="font-semibold">Upload complete!</span>
                </div>
            {:else if uploadStatus === 'error'}
                <div class="flex items-center space-x-3 text-red-600">
                    <svg class="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                    </svg>
                    <span class="font-semibold">Upload failed</span>
                </div>
            {/if}
        </div>
    </div>
{/if}

<!-- Return Confirmation Modal -->
{#if showReturnConfirmation}
    <!-- svelte-ignore a11y_click_events_have_key_events -->
    <!-- svelte-ignore a11y_no_static_element_interactions -->
    <div class="fixed inset-0 z-50 flex items-center justify-center px-4 bg-black bg-opacity-50"
         onclick={() => showReturnConfirmation = false}>
        <div class="bg-white rounded-lg shadow-xl max-w-sm w-full px-6 space-y-4x"
             style="color: #4D2DB7;"
             onclick={(e) => e.stopPropagation()}>
            <h3 class="text-xl font-semibold text-center">Are you sure?</h3>
            <p class="text-center text-base">This will erase your current recording for this task. You can only restart this task once per session</p>

            <div class="flex flex-col sm:flex-row gap-3 pt-2x">
                <button class="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-800 font-bold py-3 px-6 rounded-lg text-lg transition-colors"
                        onclick={() => showReturnConfirmation = false}>
                    Nevermind
                </button>
                <button class="flex-1 bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-6 rounded-lg text-lg transition-colors"
                        onclick={() => {
                            showReturnConfirmation = false;
                            if (returnCallback) returnCallback();
                        }}>
                    Ok
                </button>
            </div>
        </div>
    </div>
{/if}





